import moment from 'moment';

const currentYear = moment().year();
const displayMonday = moment().locale('us').weekday(1).format('M.D');
const displayMonth = moment().date() < 27 ? moment().format('MMMM') : moment().add(1, 'months').format('MMMM');

export const navigation = [
    {
        name: 'Tarot',
        link: '/tarot',
        submenu: [
            {
                name: 'Tarot Readings',
                link: '/readings-reports/tarot',
                links: [
                    {
                        name: 'FREE 3-Card Tarot Reading',
                        link: '/readings-reports/tarot-readings/free',
                        logged_in: {
                            name: 'Soulmate Tarot Reading',
                            link: '/readings-reports/tarot-readings/soulmate',
                        },
                    },
                    {
                        name: 'FREE Love Tarot Reading',
                        link: '/readings-reports/tarot-readings/free/love',
                        logged_in: {
                            name: 'Horoscope Tarot Reading',
                            link: '/readings-reports/tarot-readings/horoscope-tarot',
                        },
                    },
                    {
                        name: 'Yes or No Tarot Reading',
                        link: '/readings-reports/tarot-readings/yes-no',
                        logged_in: {
                            name: 'Relationship Analysis Tarot Reading',
                            link: '/readings-reports/tarot-readings/analysis/relationship',
                        },
                    },
                    {
                        name: 'Daily Reflection Tarot Reading',
                        link: '/readings-reports/tarot-readings/daily-reflection',
                        logged_in: {
                            name: 'Tree of Life Tarot Reading',
                            link: '/readings-reports/tarot-readings/tree-of-life',
                        },
                    },
                    {
                        name: 'All Tarot Readings',
                        link: '/readings-reports/tarot',
                    },
                ],
            },
            {
                name: 'Learn Tarot',
                link: '/tarot',
                links: [
                    {
                        name: 'Tarot Card of the Day',
                        link: '/daily-tarot-card',
                    },
                    {
                        name: 'Browse Tarot Decks',
                        link: '/tarot/decks',
                    },
                    {
                        name: 'Browse Tarot Cards',
                        link: '/tarot/cards',
                    },
                    {
                        name: `${currentYear} Tarot Forecast`,
                        link: `/tarot/reading-${currentYear}`,
                    },
                    {
                        name: 'More About Tarot',
                        link: '/tarot',
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore Tarot',
            tag:'tarot',
            url: '/news/tarot',
        },
    },
    {
        name: 'Readings',
        link: '/readings-reports',
        submenu: [
            {
                name: 'Tarot Readings',
                link: '/readings-reports/tarot',
                links: [
                    {
                        name: 'FREE Tarot Reading',
                        link: '/readings-reports/tarot-readings/free',
                        logged_in: {
                            name: 'Yes or No Tarot Reading',
                            link: '/readings-reports/tarot-readings/yes-no',
                        },
                    },
                    {
                        name: 'Relationship Bottom Line',
                        link: '/readings-reports/tarot-readings/bottom-line/relationship',
                        logged_in: {
                            name: 'Revelation Tarot Reading',
                            link: '/readings-reports/tarot-readings/revelation',
                        },
                    },
                    {
                        name: 'Self-Healing Bottom Line',
                        link: '/readings-reports/tarot-readings/bottom-line/self-healing',
                        logged_in: {
                            name: 'Love Celtic Cross Tarot Reading',
                            link: '/readings-reports/tarot-readings/celtic-cross/love',
                        },
                    },
                    {
                        name: 'Career Bottom Line',
                        link: '/readings-reports/tarot-readings/bottom-line/career',
                        logged_in: {
                            name: 'Star of David Tarot Reading',
                            link: '/readings-reports/tarot-readings/star-of-david',
                        },
                    },
                    {
                        name: 'Explore All Tarot Readings',
                        link: '/readings-reports/tarot',
                        logged_in: {
                            name: 'View All Tarot Readings',
                            link: '/readings-reports/tarot',
                        },
                    },
                ],
            },
            {
                name: 'More Readings',
                link: '/readings-reports',
                links: [
                    {
                        name: 'FREE Cosmic Profile',
                        link: '/cosmic-profile',
                        logged_in: {
                            name: 'Essential Birth Report',
                            link: 'https://product.tarot.com/product/input/?id=85600',
                        },
                    },
                    {
                        name: 'FREE Love Compatibility',
                        link: '/astrology/compatibility/love',
                        logged_in: {
                            name: 'Jupiter\'s Promises Report',
                            link: 'https://product.tarot.com/product/input/?id=85300',
                        },
                    },
                    {
                        name: 'FREE I Ching Reading',
                        link: '/readings-reports/i-ching/free',
                        logged_in: {
                            name: 'Personalized Astrology Forecast',
                            link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=35',
                        },
                    },
                    {
                        name: 'FREE I Ching Love Reading',
                        link: '/readings-reports/i-ching/free/love',
                        logged_in: {
                            name: 'I Ching Reading',
                            link: '/readings-reports/i-ching/free',
                        },
                    },
                    {
                        name: 'Explore All Free Readings',
                        link: '/readings-reports/free',
                        logged_in: {
                            name: 'Explore All Readings',
                            link: '/readings-reports',
                        },
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore All Readings & Reports',
            tag:'catalog',
            url: '/readings-reports',
        },
    },
    {
        name: 'Horoscopes',
        link: '/horoscopes',
        submenu: [
            {
                name: 'General Horoscopes',
                link: '/horoscopes',
                links: [
                    {
                        name: 'Daily Horoscope',
                        link: '/daily-horoscope',
                    },
                    {
                        name: `${displayMonth} Horoscope`,
                        link: '/horoscopes/monthly',
                    },
                    {
                        name: `${currentYear} Yearly Horoscope`,
                        link: `/horoscopes/${currentYear}`,
                    },
                    {
                        name: `${currentYear} Chinese Horoscope`,
                        link: `/horoscopes/chinese-${currentYear}`,
                    },
                    {
                        name: 'View All Horoscopes',
                        link: '/horoscopes',
                    },
                ],
            },
            {
                name: 'Love Horoscopes',
                link: '/love-and-compatibility',
                links: [
                    {
                        name: 'Daily Love Horoscope',
                        link: '/daily-love-horoscope',
                    },
                    {
                        name: `Week of ${displayMonday} Love Horoscope`,
                        link: '/astrology/weekly-love-horoscopes',
                    },
                    {
                        name: `${displayMonth} Love Horoscope`,
                        link: '/horoscopes/monthly-love',
                    },
                    {
                        name: `${currentYear} Yearly Love Horoscope`,
                        link: `/horoscopes/${currentYear}-love`,
                    },
                    {
                        name: 'More Love & Compatibility Articles',
                        link: '/news/love',
                    },
                ],
            },
        ],
        articles: {
            name: 'Featured Horoscopes',
            tag: 'horoscopes',
            url: '/news/horoscopes',
        },
    },
    {
        name: 'Astrology',
        link: '/astrology',
        submenu: [
            {
                name: 'Astrology Reports',
                link: '/readings-reports/astrology',
                links: [
                    {
                        name: 'FREE Cosmic Profile',
                        link: '/cosmic-profile',
                        logged_in: {
                            name: 'Essential Birth Report',
                            link: 'https://product.tarot.com/product/input/?id=85600',
                        },
                    },
                    {
                        name: 'FREE Love Compatibility',
                        link: '/astrology/compatibility/love',
                        logged_in: {
                            name: 'Big Picture Forecast',
                            link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=27',
                        },
                    },
                    {
                        name: 'FREE Birth Report',
                        link: 'https://product.tarot.com/product/input/?id=85600&sample=1',
                        logged_in: {
                            name: 'Romantic Compatibility',
                            link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=16',
                        },
                    },
                    {
                        name: 'FREE Personal Moon Report',
                        link: 'https://product.tarot.com/product/input/?id=85400&sample=2',
                        logged_in: {
                            name: 'Personal Moon Report',
                            link: 'https://product.tarot.com/product/input/?id=85400',
                        },
                    },
                    {
                        name: 'All Astrology Reports',
                        link: '/readings-reports/astrology',
                    },
                ],
            },
            {
                name: 'Learn Astrology',
                link: '/astrology',
                links: [
                    {
                        name: 'Zodiac Sign Traits',
                        link: '/astrology/zodiac',
                    },
                    {
                        name: 'Born on the Cusp',
                        link: '/articles/astrology/born-on-the-zodiac-cusp',
                    },
                    {
                        name: 'Current Planetary Positions',
                        link: '/astrology',
                    },
                    {
                        name: 'Astrology Articles & Videos',
                        link: '/news/astrology',
                    },
                    {
                        name: 'More About Astrology',
                        link: '/astrology',
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore Astrology',
            tag: 'astrology',
            url: '/news/astrology',
        },
    },
    {
        name: 'Numerology',
        link: '/numerology',
        submenu: [
            {
                name: 'Numerology Reports',
                link: '/numerology',
                links: [
                    {
                        name: 'Numerology Forecast',
                        link: '/readings-reports/numerology-reports/1-year-forecast/sample',
                        logged_in: {
                            name: '1-Year Numerology Report',
                            link: '/readings-reports/numerology-reports/1-year-forecast',
                        },
                    },
                    {
                        name: 'FREE Numerology Compatibility',
                        link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=4',
                        logged_in: {
                            name: 'Numerology Compatibility Report',
                            link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=2',
                        },
                    },
                    {
                        name: 'Personality Report',
                        link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=1',
                    },
                    {
                        name: 'Calculate Your Sun Number',
                        link: '/numerology/sun-numbers',
                    },
                    {
                        name: 'All Numerology Reports',
                        link: '/readings-reports/numerology',
                    },
                ],
            },
            {
                name: 'Learn Numerology',
                link: '/numerology',
                links: [
                    {
                        name: 'Daily Number',
                        link: '/daily-number',
                    },
                    {
                        name: `${currentYear} Numerology Predictions`,
                        link: `/numerology/${currentYear}-predictions`,
                    },
                    {
                        name: 'Birthday Numerology',
                        link: '/numerology/birthday',
                    },
                    {
                        name: 'Numerology Articles & Videos',
                        link: '/news/numerology',
                    },
                    {
                        name: 'More About Numerology',
                        link: '/numerology',
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore Numerology',
            tag: 'numerology',
            url: '/news/numerology',
        },
    },
    {
        name: 'Psychics',
        link: '/psychics',
        target: '_blank',
    },
    {
        name: 'I Ching',
        link: '/eastern-wisdom',
        submenu: [
            {
                name: 'I Ching Readings',
                link: '/readings-reports/feng-shui',
                links: [
                    {
                        name: 'Daily Hexagram',
                        link: '/daily-hexagram',
                    },
                    {
                        name: 'FREE I Ching Reading',
                        link: '/readings-reports/i-ching/free',
                    },
                    {
                        name: 'FREE Love I Ching Reading',
                        link: '/readings-reports/i-ching/free/love',
                    },
                    {
                        name: 'FREE Personalized Feng Shui Report',
                        link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=23&sample=1',
                        logged_in: {
                            name: 'Personalized Feng Shui Report',
                            link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=23',
                        },
                    },
                    {
                        name: 'All I Ching Readings',
                        link: '/readings-reports/feng-shui',
                    },
                ],
            },
            {
                name: 'Learn I Ching',
                link: '/eastern-wisdom',
                links: [
                    {
                        name: 'FREE Chinese Compatibility',
                        link: '/astrology/compatibility/chinese',
                        logged_in: {
                            name: 'Chinese Zodiac Signs',
                            link: '/eastern-wisdom#chinese-astro',
                        },
                    },
                    {
                        name: 'Chinese Zodiac Signs',
                        link: '/eastern-wisdom#chinese-astro',
                        logged_in: {
                            name: 'Browse All I Ching Hexagrams',
                            link: '/i-ching/hexagrams',
                        },
                    },
                    {
                        name: 'Browse All I Ching Hexagrams',
                        link: '/i-ching/hexagrams',
                        logged_in: {
                            name: 'I Ching Articles & Videos',
                            link: '/news/i-ching',
                        },
                    },
                    {
                        name: 'I Ching Articles & Videos',
                        link: '/news/i-ching',
                        logged_in: {
                            name: 'Feng Shui Articles & Videos',
                            link: '/news/feng-shui',
                        },
                    },
                    {
                        name: 'More About I CHING',
                        link: '/eastern-wisdom',
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore I Ching',
            tag: 'feng-shui',
            url: '/news/chinese',
        },
    },
];



// WEBPACK FOOTER //
// ./app/nav-config.js